// extracted by mini-css-extract-plugin
module.exports = {"Layout__Adition_Container_billboard_fixed":"_4T6M"};